export default __webpack_public_path__ + "static/mongo_db-29a97ebd4daf9e030af5a40c3783e7a0.png";